<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Salary Deal/Agreement Form
              <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
            <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Employee</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewinfo" readonly :state="!$v.model.crewkey.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Marital Status</label></b-input-group-prepend>
                        <b-form-select v-model="model.kawin" :plain="true" :options="maritalStatus" :state="!$v.model.kawin.$error"></b-form-select>
                      <b-form-checkbox  class="ml-1 mt-2" v-model="model.crewmale" value=1 unchecked-value=0 :state="!$v.model.crewmale.$error">MALE</b-form-checkbox>
                        <b-input-group-prepend><span class="ml-4 pt-2">&nbsp; Dependent(Children+Wife)&nbsp; </span></b-input-group-prepend>    
                        <b-form-input v-model="model.tanggungan" type="number" :state="!$v.model.tanggungan.$error"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">person(s)</span></b-input-group-prepend>    
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>NPWP</label></b-input-group-prepend>
                      <b-form-input v-model="model.npwp" placeholder="Tax Identification Number"></b-form-input>
                      <b-form-radio-group class="ml-2 mt-2" v-model="model.wni" name="radioWni" :state="!$v.model.wni.$error">
                          <b-form-radio value="1">Indonesian</b-form-radio>
                          <b-form-radio value="0">Expatriate</b-form-radio>
                      </b-form-radio-group>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Bank Account#</label></b-input-group-prepend>
                        <b-form-input v-model="model.bankaccno" :state="!$v.model.bankaccno.$error"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Beneficiary</span></b-input-group-prepend>
                        <b-form-input v-model="model.beneficiary" :state="!$v.model.beneficiary.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Bank Name#</label></b-input-group-prepend>
                        <b-form-input v-model="model.bankname" :state="!$v.model.bankname.$error"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Job Position</label></b-input-group-prepend>
                      <b-form-input v-model="model.pangkat" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Title</span></b-input-group-prepend>
                        <b-form-input v-model="model.jabatan" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Grade/Golongan</label></b-input-group-prepend>
                        <!-- <b-form-select v-model="model.golonganid" :plain="true" :options="jobGroups" ></b-form-select> -->
                        <b-form-input v-model="model.golongan" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Department</span></b-input-group-prepend>
                        <b-form-input v-model="model.departemen" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                    <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                        <b-form-input v-model="model.location" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Project</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.projectname" ></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Working Time</label></b-input-group-prepend>
                          <b-form-input v-model="model.workinghour" type="number" ></b-form-input>
                          <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Excl.Rest</span></b-input-group-prepend>  
                          <b-form-input v-model="model.workingtime" type="number" :state="!$v.model.workingtime.$error"></b-form-input>
                      
                          <b-form-checkbox class="ml-2 mt-2" v-model="model.overtimeable" value=1 unchecked-value=0><b>Eligible OverTime</b></b-form-checkbox>
                          <b-form-radio-group class="ml-1 mt-2" v-model="model.officer" name="radioOfficer" :state="!$v.model.officer.$error">
                            <b-form-radio value="0">Shift/Scheduled</b-form-radio>
                            <b-form-radio value="1">Daily Worker</b-form-radio>
                          </b-form-radio-group>
                    </b-input-group>
                    <b-row>
                      <b-col lg="6">
                          <b-input-group>
                              <b-input-group-prepend><label style="width:140px !important;">Pajak Penghasilan</label></b-input-group-prepend>  
                              <b-form-checkbox class="mt-1" v-model="model.gajiNett" value=1 unchecked-value=0 :state="!$v.model.gajiNett.$error"><b>Nett/Gross Up</b></b-form-checkbox>
                          </b-input-group>
                      </b-col>
                      <b-col lg="6" style="text-align:right;">
                          <b-form-radio-group v-model="model.terminate" name="radioTerminate" class="mt-2"  disabled>
                            <b-form-radio value="0">Active</b-form-radio>
                            <b-form-radio value="1">Terminate/Resign</b-form-radio>
                          </b-form-radio-group>
                      </b-col>
                    </b-row>

                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
              <b-table
                  class="mb-0"
                  ref="tblDealLines"
                  outlined striped hover small
                  style="font-size:smaller;" 
                  :items="dealLines.items"
                  :fields="dealLines.fields"
                  :current-page="dealLines.page"
                  :per-page="dealLines.limit"
                    show-empty
                  >
                      <template v-slot:cell(index)="data">
                          {{data.index + 1}}
                      </template>
                      <template v-slot:cell(NilaiKomp)="data">
                      {{data.item.NilaiKomp|numFormat}}
                      </template>
                      <template v-slot:cell(fixincome)="data">
                          <span v-if="(data.item.fixincome==1)">fixed</span>
                      </template>
                      <template v-slot:cell(daily)="data">
                          <span v-if="(data.item.daily==1)">DAILY</span>
                          <span v-else>MONTHLY</span>
                      </template>
                      <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                      </template>
                      <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                      </template>

                      <template v-slot:cell(action)="data">
                          <div class="text-center">
                          <a href="javascript:void(0)" @click="editDealLines(data.item,data.toggleDetails)">
                              <i class="fa fa-pencil"></i>
                          </a>
                          |
                          <a href="javascript:void(0)" class="text-danger" @click="delDealLines(data.index)">
                              <i class="fa fa-trash"></i>
                          </a>
                          </div>
                      </template>
                  <template v-slot:row-details="row">
                  <b-card class="row-details-form">
                      <b-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Salary Item</label></b-input-group-prepend>
                                <b-form-input readonly v-model="dealLinesObj.NmKompGaji" :state="!$v.dealLinesObj.IdKompGaji.$error" style="width:60%;"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuSalaryitemShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                                <b-input-group-prepend><span class="pt-2 ml-2 mr-1">Seq.#</span></b-input-group-prepend>
                                <b-form-input v-model="dealLinesObj.nourut" type="number"></b-form-input>
                            </b-input-group>
                                <b-input-group>
                                    <b-input-group-prepend><label>Fix/Lumspsum</label></b-input-group-prepend>
                                    <b-form-radio-group  v-model="dealLinesObj.fixincome" name="radioFixIncome" class="ml-1 mt-1" >
                                        <b-form-radio :value="1">YES (Fix Amount)</b-form-radio>
                                        <b-form-radio :value="0">NO (Depend on Timesheet)</b-form-radio>
                                    </b-form-radio-group>
                                </b-input-group>
                              <div >
                                    <span style="font-style:italic, font-size:smaller">formula variable from TimeSheet: <b>{{timesheetFormulaVar}} </b> </span>
                              </div>                            
                        </b-col>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Use Formula</label></b-input-group-prepend>
                                <b-form-checkbox class="ml-1 mt-1" v-model="dealLinesObj.userumus" value=1 unchecked-value=0 ref="chkRumus"><b>&nbsp;</b></b-form-checkbox>
                                <b-form-input size="sm" v-model="dealLinesObj.rumus" :disabled="(dealLinesObj.userumus==0)" 
                                @keyup.13.native="testFormula()"
                                :state="!$v.dealLinesObj.rumus.$error"></b-form-input>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Amount </label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                                <my-number v-model="dealLinesObj.NilaiKomp" :precision="2" :disabled="(dealLinesObj.userumus==1)" :state="!$v.dealLinesObj.NilaiKomp.$error" class="form-control text-right"></my-number>
                                <b-input-group-prepend><span class="pt-2 ml-2 mr-1">Calc. Amount</span></b-input-group-prepend>
                                <my-number v-model="dealLinesObj.NilaiFix" :precision="2" :state="!$v.dealLinesObj.NilaiFix.$error" class="form-control text-right" disabled></my-number>
                            </b-input-group>
                        </b-col>
                      </b-row>
                        <b-row class="justify-content-center">
                            <b-button class="btn btn-info mr-1" @click="saveDealLines()">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>

                  </b-card>
                  </template>                        
              </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <b-button size="sm" class="ml-1" @click="getProjectPaketGaji" >Project Salary Package</b-button>  
                    <b-button size="sm" class="ml-3" @click="addDealLines" >Add Salary Items</b-button>  
                    <!-- <b-button size="sm" class="ml-1" @click="lkuCopyShow=true" v-if="copyEnabled">Copy Items from... </b-button>   -->
                </b-col>
                <b-col cols="3" style="text-align:right;">
                        <div >
                          Showing {{(dealLines.page - 1) * dealLines.limit + 1}}
                          to <span v-if="((dealLines.page * dealLines.limit)>dealLines.total)">{{dealLines.total}}</span> <span v-else>{{dealLines.page * dealLines.limit}}</span>
                          of {{dealLines.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="dealLines.limit"  style="width:60px;">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>
                            <option>55</option>
                          </select>
                        </div>
                </b-col>
                <b-col cols="5">
                    <b-row >
                      <b-col cols="4" style="text-align:right;">
                    <div style="font-weight: bolder;display:inline; margin-top:5px;">Estimasi THP : {{model.matauang}} {{dealLines.rekapfix | numFormat}}</div>
                      </b-col>
                      <b-col cols="8">            
                        <b-pagination 
                          align="right"
                          :total-rows="dealLines.total"
                          :per-page="dealLines.limit"
                          v-model="dealLines.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
            </b-card>    
            <b-row class="justify-content-center mb-2">
                <button  class="btn btn-primary mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                <b-button class="btn btn-primary mr-1" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
        <!-- <b-modal v-model="lkuCopyShow" size="lg" header-bg-variant="primary" :hide-footer="true" title="Copy Salary Items from..." :centered="true">
            <lku-crew @click="onSelectLkuCopy"></lku-crew>
        </b-modal>         -->
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Client/Project" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
      <b-modal v-model="lkuSalaryitemShow" size="lg" :hide-footer="true" title="List of Salary Items" :centered="true" :lazy="true">
          <lku-salaryitem @click="onSelectLkuSalaryitem" ></lku-salaryitem>
      </b-modal>        
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>
<script>
import moment from 'moment';
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import crew from "../../apis/crewpaket";
import crud from "../../apis/crud";
import lkuCrew from "../lookup/lkuCrew";
import lkuCustomer from "../lookup/lkuCustomers";
import lkuSalaryitem from '../lookup/lkuSalaryitem';
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{myNumber,lkuCustomer,lkuCrew, lkuSalaryitem},
  mixins: [validationMixin],
  validations: {
        model: {
            crewkey: { required },
            contractkey: {required },
            officer: { required },
            gajiNett: { required },
            bankaccno: { required },
            bankname: { required },
            beneficiary: { required },
            kawin: { required },
            tanggungan: { required },
            crewmale: { required },
            wni: { required },
            workingtime: { required }
        },
        dealLinesObj: {
            rumus : { required:(function() {
                if ((this.dealLinesObj.userumus || 0) == 0) {
                   this.dealLinesObj.rumus='';
                    return true;
                } else if ((this.dealLinesObj.rumus || '')==''){
                    return false;
                } else return true;
            }) },
            fixincome: { required },
            IdKompGaji: { required },
            NilaiKomp : { required:(function() {
                if ((this.dealLinesObj.userumus || 0) == 1) {
                    this.dealLinesObj.NilaiKomp='';
                    return true;
                } else if ((this.dealLinesObj.NilaiKomp || 0)==0){
                    return false;
                } else return true;
            }) },
            NilaiFix : { required },
        },
  }, 
  data () {
    return {
        horizontal:true,
        copyEnabled:true,
        model:{crewkey: '',contractkey:'',
            workingtime: 8,
            overtimeable: 0,
            gajiNett: 1,
            bankaccno: '',
            bankname: '',
            beneficiary: '',
            kawin: '',
            tanggungan: '',
            crewmale: '',
            wni: '',
            officer:0,
             matauang:'IDR', workingtime:8},
        lkuCrewShow:false,
        lkuCopyShow:false,
        lkuCustomerShow:false,
        lkuSalaryitemShow:false,
        currency:[{value:'IDR',text:'IDR'}],
        maritalStatus: [{value:0,text:'TDK KAWIN'},{value:1,text:'KAWIN'},{value:2,text:'KAWIN BERPISAH'}],
        departments:[],
        jobPositions:[],
        jobGroups:[],
        dealLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "NmKompGaji",
                    label: "Salary Item Name"
                },
                {
                    key: "KdKompGaji",
                    label: "Salary Item Code",
                    thStyle: "width:140px",
                },
                {
                    key: "NilaiKomp",
                    label: "Amount",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right",
                    sortable: true,
                },
                {
                    key: "rumus",
                    label: "Formula",
                },
                {
                    key: "fixincome",
                    label: "Fix/Lumpsump",
                    thStyle: "width:120px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        dealLinesObj:{IdKompGaji:'', NilaiFix:0, userumus:0, rumus:'', fixincome:1, NilaiKomp:''},
        timesheetFormulaVar:[],
        timesheetFormulaVal:[]
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      invalidDealLines() {
        this.$v.dealLinesObj.$touch();
        return this.$v.dealLinesObj.$invalid;
      },
      fixincome() {
          return this.dealLinesObj.fixincome;
      },
  },
  watch: {
      fixincome: function (newval){
          this.dealLinesObj.userumus=(!newval) ? 1: 0;
          console.log('this.dealLinesObj.userumus : ',this.dealLinesObj.userumus);
        //   console.log('chkRumus : ',this.$refs.chkRumus);
      },
  },
  created: async function(){
      if (this.$route.params.crewkey)  {
          toastr.info('Loading Crew Detail, please wait')
          try {
            // const data = await crew.detail(this.$route.params);  
            const [t,a,b,c,data] = await Promise.all([crud.list({
                                                tablename:'timesheetvar',
                                                page: 1,
                                                limit: 15,
                                                total: 0,
                                                sortBy: 'tvarname',
                                                sortDesc: false
                                            }),crew.department(),crew.position(),crew.group(),crew.detail(this.$route.params)]) ;
            this.departments = a; 
            this.jobPositions = b; 
            this.jobGroups = c; 
            t.forEach((tv)=>{
                this.timesheetFormulaVar.push(tv.tvarname);
                this.timesheetFormulaVal.push(tv.tvarvalue);
            });

            for (var key in data.crew) {
                this.model[key] = data.crew[key];
            }
            this.model.crewinfo=this.model.crewname + ' | '+ this.model.crewnik;
            for (var key in data.contract) {
                this.model[key] = data.contract[key];
            }
            // this.$forceUpdate();
            this.dealLines.items=data.contractLines;
            this.dealLines.total=this.dealLines.items.length;
            if (this.dealLines.total>0) {
                this.copyEnabled=false;
            }
            this.dealLines.rekapfix = this.dealLines.items.reduce((a, b) => a + b.NilaiFix, 0);

            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "Error Info",10000);                              
          }
      } else {
            const [t,a,b,c] = await Promise.all([crud.list({
                                                tablename:'timesheetvar',
                                                page: 1,
                                                limit: 15,
                                                total: 0,
                                                sortBy: 'tvarname',
                                                sortDesc: false
                                            }),crew.department(),crew.position(),crew.group()
                        ]) ;
            this.departments = a; 
            this.jobPositions = b; 
            this.jobGroups = c; 
            t.forEach((tv)=>{
                this.timesheetFormulaVar.push(tv.tvarname);
                this.timesheetFormulaVal.push(tv.tvarvalue);
            });
      }

  },
  methods:{
    onSelectLkuCustomer: async function (_selected) {
            this.model.projectname = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
            this.model.projectid = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    onSelectLkuCrew: async function (_selected) {
        this.model.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
            for (var key in _selected) {
                this.model[key] = _selected[key];
            }        
        this.lkuCrewShow=false;
    },
    getProjectPaketGaji: async function () {
        if (this.model.projectid){
            const dealItems = await crew.projectpaketgaji(this.model) ;
            console.log('dealItems :', dealItems);                                
            this.dealLines.items=[];
            dealItems.forEach((item)=>{
                this.dealLines.items.push({
                    IdKompGaji: item.IdKompGaji, 
                    KdKompGaji: item.KdKompGaji,
                    NmKompGaji: item.NmKompGaji,
                    userumus: item.userumus, 
                    rumus: item.rumus, 
                    fixincome: item.fixincome, 
                    NilaiKomp: item.NilaiKomp,
                    NilaiFix: item.NilaiFix
                });
            });
            this.dealLines.total=this.dealLines.items.length;
            this.dealLines.rekapfix = this.dealLines.items.reduce((a, b) => a + b.NilaiFix, 0);
        } else {
            toastr.error('The Employee is Not Project Crew');
        }

        // this.lkuCopyShow=false;
    },    
    onSelectLkuSalaryitem: function(_selected){
        this.dealLinesObj.IdKompGaji =_selected.IdKompGaji;
        this.dealLinesObj.NmKompGaji =_selected.NmKompGaji;
        this.dealLinesObj.KdKompGaji =_selected.KdKompGaji;
        this.dealLinesObj.fixincome =(_selected.Upah) ? 0:1;
        this.dealLinesObj.JenisKomp = _selected.JenisKomp;
        this.dealLinesObj.rumus =_selected.rumus;

        this.lkuSalaryitemShow=false;
    },
    closeDealLines: function(){
        const opened= this.dealLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addDealLines : function () {
        this.closeDealLines();
        const obj={_showDetails:true,IdKompGaji:'', rumus:'', fixincome:'0', NilaiKomp:''};
        this.dealLines.selected = obj;
        this.dealLinesObj.fixincome=1;
        this.dealLinesObj.NilaiKomp = 0;
        this.dealLinesObj.rumus = '';
        this.dealLinesObj.IdKompGaji = '';
        this.dealLinesObj.nourut = this.dealLines.items.length+1;
        this.dealLines.items.push(obj);
        this.dealLines.total=this.dealLines.items.length;
    },
    editDealLines : function (obj,callback) {
        this.closeDealLines();
        this.dealLines.selected = obj;
        for (var key in this.dealLinesObj) {
            this.dealLinesObj[key] = '';
        }
        for (var key in obj) {
            this.dealLinesObj[key] = obj[key];
        }
        this.dealLinesObj.nourut = this.dealLinesObj.nourut || this.dealLines.items.findIndex( i => i.IdKompGaji==obj.IdKompGaji);
        callback();
    },
    delDealLines: function (index) {
        if (index > -1) {
        this.dealLines.items.splice(index, 1);
        }
        this.dealLines.total=this.dealLines.items.length;
        this.dealLines.rekapfix = this.dealLines.items.reduce((a, b) => a + b.NilaiFix, 0);
    },
    testFormula: function() {
        try {   
            if (this.dealLinesObj.userumus==1) {
                let geval=eval;
                this.dealLines.items.forEach((item)=>{
                    if (item.KdKompGaji) {
                        geval(`${item.KdKompGaji}=${item.NilaiFix || 1};`);
                    }
                });  
                this.timesheetFormulaVar.forEach((item,index)=>{
                    geval(`${item}= ${this.timesheetFormulaVal[index]};`);
                });  
                let NilaiFix = geval(`${this.dealLinesObj.rumus};`);
                this.dealLinesObj.NilaiFix= NilaiFix || 0;
            } else {
                this.dealLinesObj.NilaiFix=this.dealLinesObj.NilaiKomp;
            }

        } catch (error) {
            console.log('error : ', error);
            if (error.message) {
                toastr.error(error.message,'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error),'Error Info',10000);
            }
        }
    },
    saveDealLines: async function (callback) {
        this.testFormula();
        if (this.invalidDealLines) {
            console.log('validation : ', this.$v.dealLinesObj);
            console.log('model obj : ',this.dealLinesObj);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
                    for (var key in this.dealLinesObj) {
                        this.dealLines.selected[key] = this.dealLinesObj[key];
                    }
                    this.dealLines.total=this.dealLines.items.length;
                    this.dealLines.rekapfix = this.dealLines.items.reduce((a, b) => a + b.NilaiFix, 0);
                    this.dealLines.selected._showDetails=false;
                    if (callback) callback();
                    const sortedLines= this.dealLines.items.sort((a, b) => parseInt(a.nourut) - parseInt(b.nourut));   
                    this.dealLines.items= sortedLines;                
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }
            }
        }
    },

    save: async function(){
        // this.model.npwp_name = this.model.npwp_name || this.model.itemname;
        // this.model.npwp_address1 = this.model.npwp_address1 || this.model.item_address1 ;
        // this.model.npwp_address2 = this.model.npwp_address2 || this.model.item_address2;
        // this.model.npwp_city = this.model.npwp_city || this.model.item_city;
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
                    let newDealLines = this.dealLines.items.reduce((newArr, item, idx) => {
                        if ((item.IdKompGaji) && ((item.NilaiKomp) || (item.rumus))) {
                            item.nourut = item.nourut || (idx+1); 
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);

              data.lines = newDealLines;
              await crew.save(data);
              this.close();
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message, "Error Info",10000);
                } else {
                    toastr.error(JSON.stringify(error), "Error Info",10000);
                }              
            }
        }
    },
    close(){
        router.push({name: 'hrm.salarydeal'});
    },    
  }
}
</script>